import React from 'react'

import LABEL from '../../../business-const/Label/Label'

import {
    formataValor,
    formataPerc,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    existeTabelaEvolucaoValorResgate,
} from '../seguroVidaCotacao-form/SeguroVidaCotacaoServiceCotacao'



const GestaoPatrimonialFormResumoPatrimonialTotalAtivos = ( { values, estudo, report, popup, simulacaoFinanceira,
    analisePatrimonial, semAlavancagem } ) => {

    const ativos = estudo.current.ativos +
        (
            values.exibirCapitalSeguradoCarteiraInvestimentos && !semAlavancagem
                ?
                    values.valorCSVidaInteiraApoliceCliente + values.valorCSVidaInteiraApoliceConjuge +
                        (
                            existeTabelaEvolucaoValorResgate(values)
                                ?
                                    values.valorCSVidaInteiraCotacaoCliente + values.valorCSVidaInteiraCotacaoConjuge -
                                        (
                                            values.premioVidaInteiraOriundoCarteiraInvestimentos &&
                                            values.idRecursoFinanceiroOrigemOrigemPremioVidaInteira
                                                ?
                                                    values.valorPremioAnualizadoVidaInteiraCliente +
                                                        values.valorPremioAnualizadoVidaInteiraConjuge
                                                :
                                                    0
                                        )
                                :
                                    0
                        )
                :
                    0
        )

    const label = LABEL.ativos.toUpperCase() + ' = ' + formataValor(ativos, 2)

    const ativosExterior = estudo.current.valorPatrimonioImobilizadoExterior + 
        estudo.current.valorRecursosFinanceirosExterior

    return (
        <GridContainer>
            <GridItem12
                className={
                    (report ? 'mt--20 mb-2': analisePatrimonial ? 'mt--10 ml-35' : 'mt-0') +
                        (report || popup || simulacaoFinanceira || analisePatrimonial ? '' : ' text-white')
                }
                ////align={(simulacaoFinanceira || analisePatrimonial) && !report ? 'center' : 'left'}
                align={simulacaoFinanceira ? 'center' : 'left'}
            >
                {simulacaoFinanceira
                    ?
                        <h5>
                            {label}
                        </h5>
                    :
                        report
                            ?
                                <>
                                    <h5>
                                        {label}
                                    </h5>

                                    {ativosExterior > 0 && (
                                        <h6
                                            className='mt-5'
                                        >
                                            {LABEL.ativosExterior.toUpperCase() + ' = ' + formataValor(ativosExterior, 2) + ' (' +
                                            formataPerc(ativosExterior / ativos * 100, 2) + ')'
                                            }
                                        </h6>
                                    )}
                                </>
                            :
                                <>
                                    <h3>
                                        {label}
                                    </h3>

                                    {ativosExterior > 0 && (
                                        <h4
                                            className='mt-5'
                                        >
                                            {LABEL.ativosExterior.toUpperCase() + ' = ' + formataValor(ativosExterior, 2) + ' (' +
                                            formataPerc(ativosExterior / ativos * 100, 2) + ')'
                                            }
                                        </h4>
                                    )}
                                </>
                }
            </GridItem12>
        </GridContainer>
    )
}

export default GestaoPatrimonialFormResumoPatrimonialTotalAtivos